import React from "react";
import Helmet from "react-helmet";
import { isNonProdEnviroment } from "../utils/utils";

function HeadChange() {
    const environment = isNonProdEnviroment(window.location.origin);
    const environmentTitle = environment ? `[${environment.toUpperCase()}] - ` : "";
    return (
        <Helmet>
            <title>{`${environmentTitle}Sovos SAF-T`}</title>
            <link rel="icon" type="image/png" href={`/sovos.png`} />
        </Helmet>
    );
}
export default HeadChange;
